<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-account-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Register',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreAccountView: () => import('../components/core/AccountView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
